
import * as React from "react";

export const generateMarkup = (rawContent: string) => {
  const content = {
    __html: rawContent || ''
  };

  return <div dangerouslySetInnerHTML={content} />;
};